/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            new Site().run();
        };
        Site.prototype.run = function () {
            Site.initResponsiveVideo();
            Site.initResponsiveTables();
            Site.initFrontpage();
            Site.initIcon();
            Site.initEmployeeAlphaFilterHelper();
        };
        Site.is = function (bodyClass) {
            return document.body.classList.contains(bodyClass);
        };
        Site.initResponsiveVideo = function () {
            var iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
            Array.prototype.forEach.call(iframes, function (el) {
                var videoWrapper = document.createElement('div');
                videoWrapper.classList.add('video');
                videoWrapper.style.maxWidth = el.width;
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
                responsiveWrapper.parentNode.insertBefore(videoWrapper, responsiveWrapper);
                videoWrapper.appendChild(responsiveWrapper);
            });
        };
        Site.initResponsiveTables = function () {
            var tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, function (el) {
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        };
        Site.initFrontpage = function () {
            if (!Site.is('frontpage')) {
                return;
            }
        };
        Site.initIcon = function () {
            var iconboxes = document.querySelectorAll('body .icon__box .link .icon');
            Array.prototype.forEach.call(iconboxes, function (el) {
                var icon = el.getAttribute('data-icon');
                if (icon && icon.length) {
                    el.setAttribute("style", "background: url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;");
                }
            });
        };
        Site.initEmployeeAlphaFilterHelper = function () {
            if (!Site.is('employees')) {
                return;
            }
            document.querySelectorAll('.filterControls .alphaFilter a').forEach(function (anchor) {
                anchor.addEventListener('click', function (e) {
                    setTimeout(function () {
                        var selected = document.querySelector('.filterControls .alphaFilter a.selected');
                        if (selected !== null) {
                            document.body.classList.add('employee-alpha-selected');
                        }
                        else {
                            document.body.classList.remove('employee-alpha-selected');
                        }
                    }, 100);
                });
            });
            document.querySelectorAll('.filterControls .linksFilter a').forEach(function (anchor) {
                anchor.addEventListener('click', function (e) {
                    document.body.classList.remove('employee-alpha-selected');
                });
            });
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
